import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const ReferralProgramPage = React.lazy(
  () => import('modules/referral_program/pages/ReferralProgramPage')
)

const referralProgramRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.settings.referralProgram.path,
    element: <ReferralProgramPage />,
    handle: {
      meta: () => ({
        title: i18n.t('company_settings.general.factorial_referral_program.page_title'),
      }),
    },
  },
]

export default referralProgramRoutes
